import React, { Component ,useState} from 'react';

import compose from 'recompose/compose';

// Material helpers
import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CircularProgress from '@material-ui/core/CircularProgress';
import PerfectScrollbar from 'react-perfect-scrollbar';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import WeekCalendar from 'react-week-calendar';
import 'react-week-calendar/dist/style.css'
// Component styles
import {getDatesMaintenance} from '../../../services/getDatesMaintenance'
import {getDataMaintenance} from '../../../services/getMaintenance'
import { api_host , api_auth} from '../../../common/globals/constants';
import styles from './styles';
import moment from 'moment'
import 'moment/locale/es'
moment.locale('es')


class Activities extends Component {
    constructor(props) {
        //console.log('props act', props)
        //console.log(JSON.parse(sessionStorage.getItem("listaObjetivosOnline")))
        super(props);
        //this.myCallback = this.myCallback.bind(this);
        this.state = {
            selectRanges:{},
            load:true,
            dataError:false,
            events:[],
            begin:moment().subtract(6,'days'),
            boolean:false
        }
    }

    componentDidUpdate(prevProps, prevState) {
      if(prevState.boolean!== this.state.boolean){
          //console.log('up sidebar')
          this.getDataFromAPI()
      }
    }
    componentDidMount() {
      this.getDataFromAPI();
    }


    getDataFromAPI(){
      let token = sessionStorage.getItem('key')
      let user = sessionStorage.getItem('user')
      let client = sessionStorage.getItem('client_id')
      const {begin}=this.state
      var date=begin.format('YYYY-MM-DD')
      getDataMaintenance(client, token, date, user, 0).then(data=>{
        try {
          this.processData(data)   
                  
        } catch (error) {
            this.setState({
                dataError: true,
                load: false
            });
        }
      })
        
    }
    processData(data){
      //console.log(data)
      var listObjectives=JSON.parse(sessionStorage.getItem("listaObjetivosOnline"))
      //console.log(listObjectives)
      var newList=[]
      data.map(ele=>{
        //console.log(ele.objetivo_id)
        var valueOK=false
        ele.objetivo_id.map(obj=>{
          //console.log(obj)
          if(listObjectives.filter(i=>i.objetivo_id===obj).length>0){
            valueOK=true
          }
        })
        if(valueOK){
          var start=(moment(ele.fecha_inicio))
          var end=moment(ele.fecha_termino)
          var value=ele.titulo
          newList.push({start:start, end:end, value:value, estado:ele.estado, usuario:ele.nombre,comentario:ele.comentario, objetivos:ele.objetivos})
        }
        
      })
      this.setState({
        load: false,
        events:newList
      });
    }
    changeCalendar=(e)=>{
      const {begin}=this.state
      //console.log(e.currentTarget.value)
      if(e.currentTarget.value==='0'){
        this.setState(prevState=>({
          begin:begin.subtract(6, 'days'),
          boolean:!prevState.boolean,
          load:true
        }));
      }
      if(e.currentTarget.value==='1'){
        this.setState(prevState=>({
          begin:begin.add(6, 'days'),
          boolean:!prevState.boolean,
          load:true
        }));
      }
      if(e.currentTarget.value==='2'){
        this.setState(prevState=>({
          begin:moment().subtract(6,'days'),
          boolean:!prevState.boolean,
          load:true
        }));
      }
    }
    modal=(value)=>{
      const {classes}=this.props
      if(typeof(value.usuario)==="undefined"){
        return<Grid
                container
                spacing={1}
                className={classes.modal}
              >
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  xl={12}
                  style={{textAlign:"center"}}                                     
                >
                </Grid>
              </Grid>
      }
      return <Grid
              container
              spacing={1}
              className={classes.modal}
            >
              <Grid
                item
                xs={3}
                sm={3}
                md={3}
                xl={3}
                //style={{textAlign:"center"}}                                     
              >
                <Typography>Usuario: </Typography>
              </Grid>
              <Grid
                item
                xs={9}
                sm={9}
                md={9}
                xl={9}
                //style={{textAlign:"center"}}                                     
              >
                {value.usuario}
              </Grid>
              <Grid
                item
                xs={3}
                sm={3}
                md={3}
                xl={3}
                //style={{textAlign:"center"}}                                     
              >
                <Typography>Estado: </Typography>
              </Grid>
              <Grid
                item
                xs={9}
                sm={9}
                md={9}
                xl={9}
                //style={{textAlign:"center"}}                                     
              >
                {value.estado}
              </Grid>
              <Grid
                item
                xs={3}
                sm={3}
                md={3}
                xl={3}
                //style={{textAlign:"center"}}                                     
              >
                <Typography>Titulo: </Typography>
              </Grid>
              <Grid
                item
                xs={9}
                sm={9}
                md={9}
                xl={9}
                //style={{textAlign:"center"}}                                     
              >
                {value.value}
              </Grid>
              <Grid
                item
                xs={3}
                sm={3}
                md={3}
                xl={3}
                //style={{textAlign:"center"}}                                     
              >
                <Typography>Inicio: </Typography>
              </Grid>
              <Grid
                item
                xs={9}
                sm={9}
                md={9}
                xl={9}
                //style={{textAlign:"center"}}                                     
              >
                {value.start.format("YYYY-MM-DD HH:mm:ss")}
              </Grid>
              <Grid
                item
                xs={3}
                sm={3}
                md={3}
                xl={3}
                //style={{textAlign:"center"}}                                     
              >
                <Typography>Termino: </Typography>
              </Grid>
              <Grid
                item
                xs={9}
                sm={9}
                md={9}
                xl={9}
                //style={{textAlign:"center"}}                                     
              >
                {value.end.format("YYYY-MM-DD HH:mm:ss")}
              </Grid>
              <Grid
                item
                xs={3}
                sm={3}
                md={3}
                xl={3}
                //style={{textAlign:"center"}}                                     
              >
                <Typography>Monitoreos: </Typography>
              </Grid>
              {value.objetivos.map(obj=>(
                <Grid
                  item
                  xs={3}
                  sm={3}
                  md={3}
                  xl={3}
                  //style={{textAlign:"center"}}                                     
                >
                  {obj.nombre}
                </Grid>
              ))}
            </Grid>
    }
    render() {
        const {load, events,begin}=this.state
        const {classes}=this.props
        /*const sele=[{
          start: moment().subtract(1, 'hours'),
          end: moment(),
          value: 'hola'
        },]*/
        //console.log('period', this.props)
        if(load===true){
          return(
            <Card >
                  <Typography
                      align="center"
                      variant="h5">
                      <CircularProgress
                          variant="indeterminate"      
                          size={24}                         
                      />
                      Cargando Información...
                  </Typography> 
            </Card>
          )
        }else{
          return (
            <Card >
                <CardContent >
                  <Grid
                    container
                    spacing={1}
                  >
                    <Grid
                      item
                      xs={1}
                      sm={1}
                      md={1}
                      xl={1}
                      style={{textAlign:"center"}}                                     
                    >
                      <Button style={{backgroundColor: 'white', width:"100%"}} value="0" onClick={this.changeCalendar} variant="outlined" color="primary" size="small">
                        <ArrowBackIosIcon />
                      </Button>
                    </Grid>
                    <Grid
                      item
                      xs={1}
                      sm={1}
                      md={1}
                      xl={1}
                      style={{textAlign:"center"}}                                     
                    >
                      <Button style={{backgroundColor: 'white', width:"100%"}} value="1" onClick={this.changeCalendar} variant="outlined" color="primary" size="small">
                        <ArrowForwardIosIcon />
                      </Button>
                    </Grid>
                    <Grid
                      item
                      xs={1}
                      sm={1}
                      md={1}
                      xl={1}
                      style={{textAlign:"center"}}                                     
                    >
                      <Button style={{backgroundColor: 'white', width:"100%"}} value="2" onClick={this.changeCalendar} variant="outlined" color="primary" size="small">
                        <Typography variant="button"> HOY </Typography>
                      </Button>
                    </Grid>
                    <Grid
                      item
                      xs={9}
                      sm={9}
                      md={9}
                      xl={9}
                      style={{textAlign:"center"}}                                     
                    >
                      <Typography variant="button"> {moment().format("YYYY-MM-DD HH:MM:SS")} </Typography>
                    </Grid>
                  </Grid>
                  <WeekCalendar className={classes.calendarFont}
                    selectedIntervals={events}
                    numberOfDays={7}
                    firstDay={begin}
                    //dayFormat
                    scaleUnit={30}
                    useModal={true}
                    modalComponent={this.modal}
                     />
                </CardContent>
            </Card>
            
        );
        }
        
    }
}


export default compose(withWidth(), withStyles(styles))(Activities);
